import { updateProfileDataThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { TrashSquareIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './styles.module.scss';
import { useEffect } from 'react';
import {
    selectProfileData,
    selectUpdatingProfileData,
    selectSelectedWorkExperience,
} from '../../../../../store/workspace/selectors';
import {
    setSelectedWorkExperience,
    setDeleteWorkExperienceModal,
} from '../../../../../store/workspace/slice';

export default function DeleteWorkExperience() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const isLoading = useSelector(selectUpdatingProfileData);
    const selectedExperience = useSelector(selectSelectedWorkExperience);

    useEffect(() => {
        return () => {
            dispatch(setSelectedWorkExperience(null));
        }
    }, []);

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;
        const filteredList = profile.workExperience.filter(i => i.id !== selectedExperience?.id);
        dispatch(updateProfileDataThunk({ ...rest, workExperience: [...filteredList] }));
    };

    return (
        <Modal
            size='sm'
            title='Delete work experience'
            icon={<TrashSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setDeleteWorkExperienceModal(false))}
        >
            <h3>Are you sure you want to delete "{selectedExperience?.jobTitle}" ?</h3>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setDeleteWorkExperienceModal(false))}
                />
                <Button
                    type='Error'
                    text='Delete'
                    onClick={submit}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
};
